import axios from 'axios'
import { Unauthorized, NotFound } from '@/constants/responseStatus'
import router from '@/router'
import store from '@/store/index'
import { getToken } from '@/utils/auth'

const api = axios.create({
	baseURL: process.env.VUE_APP_API_ROOT ? process.env.VUE_APP_API_ROOT : 'http://localhost:4000/',
})
// request interceptor
api.interceptors.request.use(config => {
	// do something before request is sent  
		if (store.getters.token) {
			// let each request carry token
			config.headers['x-access-token'] = getToken()
		}
		return config
	},
	error => {
		// do something with request error
		return Promise.reject(error)
	}
)

api.interceptors.response.use((response) => {
	return Promise.resolve(response)
}, async (error) => {
	if (error.response && error.response.status == 401) {
		await store.dispatch('user/logout');
		router.push(`/login?redirect=${router.currentRoute.fullPath}`)
	}
	return Promise.reject(error)
})

export default api
